import { Injectable } from '@angular/core';
import * as _ from 'google-libphonenumber';

import { CountryCodeData } from './country-code-data';
import { CountryInternational } from '../models';

@Injectable({
	providedIn: 'root'
})
export class CountryIntlService {
	private allCountries: CountryInternational[] = [];

	constructor(private countryCodeData: CountryCodeData) { }

	getCountriesData(phoneType: _.PhoneNumberType): CountryInternational[] {
		if (this.allCountries.length > 0) {
			return this.allCountries;
		}
		this.countryCodeData.allCountries.forEach(c => {
			const country = new CountryInternational();
			country.name = c[0].toString();
			country.iso2 = c[1].toString();
			country.dialCode = c[2].toString();
			country.priority = +c[3] || 0;
			country.areaCode = +c[4] || null;
			country.flagClass = country.iso2.toLocaleLowerCase();
			country.placeHolder = this.getExampleNumber(
				country.iso2.toUpperCase(),
				_.PhoneNumberFormat.INTERNATIONAL,
				phoneType
			);
			this.allCountries.push(country);
		});

		return this.allCountries;
	}

	getCountryData(countryIso2: string, phoneType: _.PhoneNumberType): CountryInternational {
		const countryInfo = this.countryCodeData.allCountries.find(
			(countryData) => {
				return countryData[1].toString().toLocaleLowerCase() === countryIso2.toLowerCase();
			}
		);

		if (!countryInfo) {
			return null;
		}

		const country = new CountryInternational();
		country.name = countryInfo[0].toString();
		country.iso2 = countryInfo[1].toString();
		country.dialCode = countryInfo[2].toString();
		country.priority = +countryInfo[3] || 0;
		country.areaCode = +countryInfo[4] || null;
		country.flagClass = country.iso2.toLocaleLowerCase();
		country.placeHolder = this.getExampleNumber(
			country.iso2.toUpperCase(),
			_.PhoneNumberFormat.INTERNATIONAL,
			phoneType
		);

		return country;
	}

	getExampleNumber(countryIso2, format, numberType): string {
		try {
			const phoneUtil = _.PhoneNumberUtil.getInstance();
			const numberObj = phoneUtil.getExampleNumberForType(
				countryIso2,
				numberType
			);
			return phoneUtil.format(numberObj, format);
		} catch (e) {
			return e;
		}
	}

	formatNumberToInternational(phoneNumber: string, countryIso2: string): string {
		try {
			const phoneUtil = _.PhoneNumberUtil.getInstance();
			const number = phoneUtil.parse(phoneNumber, countryIso2);
			const formatedNumber = phoneUtil.format(number, _.PhoneNumberFormat.INTERNATIONAL);

			return formatedNumber;

		} catch (e) {
			return phoneNumber;
		}
	}
}
